// Import File
import './App.css';
import {About} from'./MYComponant/About';
import {Header} from'./MYComponant/Header';
import {Footer} from'./MYComponant/Footer';
import {Home} from './MYComponant/Home'
import React from 'react';

//For Routing
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

// Main Application
function App() {
  
  return ( 
    <> 
    <BrowserRouter>
      <Header title="My Todos List" searchBar={false} /> 
      <Routes>
          <Route path="/" element={<Home/>}>
          </Route>
          <Route path="/about" element={ <About />}>
        
          </Route> 
        </Routes> 
      <Footer />
    </BrowserRouter>
    </>
  );
}

export default App;
